import styled from 'styled-components';
import { COLOR, smartphone } from '../../../styles/variables';

const height = '2.25rem';

export const AuthorWrapper = styled.div`
    display: flex;
    margin-top: 2rem;
    margin-bottom: 1.5rem;
`;

export const AuthorList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;

    @media ${smartphone} {
        flex-direction: column;
    }
`;

export const AuthorItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: ${height};
    margin: 0 1rem 1rem 0;
    background-color: ${COLOR.br24.veryLightGrey};

    &:hover {
        background-color: ${COLOR.br24.lightGrey};
    }
`;

export const AuthorLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLOR.br24.black};
    text-decoration: none;
`;

export const AuthorImage = styled.img`
    height: ${height};
    border-radius: 50%;
`;

export const AuthorName = styled.span`
    padding: 0 1rem 0 0.85rem;
`;

export const Prefix = styled.div`
    line-height: ${height};
    margin: 0 1rem 1rem 0;
    font-weight: 600;
`;
